import type { CountryCode } from 'libphonenumber-js/max';

import { parsePhoneNumber } from 'libphonenumber-js/max';

import { INVALID_NUMBER_ERROR } from './constants';

/**
 * Check if phone is valid
 * @param phone phone # to validate
 * @param countryCode phone # country code
 * @returns phone on international format
 */
const parseToInternationalPhoneNumber = (
  phone: string,
  countryCode: CountryCode = 'US'
) => {
  try {
    const phoneNumber = parsePhoneNumber(phone, countryCode);

    //replace all
    return phoneNumber.formatInternational().replace(/\s+/g, '');
  } catch {
    throw new Error(INVALID_NUMBER_ERROR);
  }
};

export { parseToInternationalPhoneNumber };
